import React from 'react';

import Icon from '../Icon/Icon';

const LocateBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path
                    d='M24 38.043c7.756 0 14.043-6.287 14.043-14.043 0-7.756-6.287-14.043-14.043-14.043-7.756 0-14.043 6.287-14.043 14.043 0 7.756 6.287 14.043 14.043 14.043z'
                    stroke='#272A33'
                    strokeWidth='2'
                />
                <path
                    d='M24 29.174a5.174 5.174 0 1 0 0-10.348 5.174 5.174 0 0 0 0 10.348z'
                    stroke='#272A33'
                    strokeWidth='2'
                    fill='#00D1D2'
                    fillRule='nonzero'
                />
                <path
                    d='M24 26.957a2.957 2.957 0 1 0 0-5.914 2.957 2.957 0 0 0 0 5.914z'
                    fill='#00D1D2'
                    fillRule='nonzero'
                />
                <path
                    stroke='#272A33'
                    strokeWidth='2'
                    strokeLinecap='round'
                    d='M24 34.7V41M24 13.3V7M34.7 24H41M7 24h6.3'
                />
            </g>
        </Icon>
    );
};

export default LocateBlueIcon;
